import { call, put } from "redux-saga/effects";
import { ACTIONS, API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getEmployerJobs(action: any): any {
  try {
    const { employerId, params = {} } = action.payload || {};

    if (!employerId) {
      action && action.callbackError && action.callbackError("Employer ID is required");
      return;
    }

    const url = `${API_URL.JOB.EMPLOYER_JOBS}${employerId}`;
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_EMPLOYER_JOBS,
        payload: resp.data.data.jobs,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobDetails(action: any): any {
  try {
    const { jobId } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const url = `${API_URL.JOB.JOB_DETAILS}${jobId}`;
    const resp = yield call(CallApi.GET, url, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* updateJobStatus(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.PUT,
    `${API_URL.JOB.UPDATE_STATUS}${action.payload.jobId}`,
    action.payload.data,
    true
  );
}

export function* cloneJob(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.POST,
    `${API_URL.JOB.CLONE_JOB}${action.payload.jobId}`,
    action.payload.data,
    true
  );
}

export function* getJobCandidates(action: any): any {
  try {
    const { jobId, params = {} } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const url = API_URL.JOB.JOB_CANDIDATES(jobId);
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_JOB_CANDIDATES,
        payload: resp.data.data,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getScreening(action: any): any {
  try {
    const { jobId, limit = 10, offset = 0, search, ...otherParams } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const params: any = {
      job_id: jobId,
      limit,
      offset,
      ...otherParams, // Include any additional parameters
    };

    // Add search parameter if provided
    if (search && search.trim()) {
      params.search = search.trim();
    }

    const resp = yield call(CallApi.GET, API_URL.JOB.SCREENING, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_SCREENING,
        payload: resp.data.data,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getCandidateDetails(action: any): any {
  try {
    const { jobId, candidateId } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    if (!candidateId) {
      action && action.callbackError && action.callbackError("Candidate ID is required");
      return;
    }

    const url = API_URL.JOB.CANDIDATE_DETAILS(jobId, candidateId);
    const resp = yield call(CallApi.GET, url, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_CANDIDATE_DETAILS,
        payload: resp.data.data,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* bulkResumeUpload(action: any): any {
  try {
    const { files, jobEmpId } = action.payload || {};

    if (!files || files.length === 0) {
      action && action.callbackError && action.callbackError("No files provided for upload");
      return;
    }

    if (!jobEmpId) {
      action && action.callbackError && action.callbackError("Job employer ID is required");
      return;
    }

    // Create FormData for multipart/form-data upload
    const formData = new FormData();

    // Append each file with the name 'files[]' as specified in the API
    files.forEach((file: File) => {
      formData.append("files[]", file);
    });

    // Append job_emp_id as specified in the API
    formData.append("job_emp_id", jobEmpId.toString());

    const resp = yield call(CallApi.POST, API_URL.JOB.BULK_RESUME_UPLOAD, formData, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobStatusCounts(action: any): any {
  try {
    const { jobIds = [] } = action.payload || {};

    // Build query parameters for job_ids[]
    const params: any = {};
    if (jobIds && jobIds.length > 0) {
      params["job_ids[]"] = jobIds;
    }

    const resp = yield call(CallApi.GET, API_URL.JOB.JOB_STATUS_COUNTS, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getAppliedJobsLastSevenDays(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.JOB.APPLIED_JOBS_LAST_SEVEN_DAYS, action.payload, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobAllStatusCounts(action: any): any {
  try {
    const params: any = {};

    // Add job_ids[] array if provided
    if (action.payload?.job_ids && Array.isArray(action.payload.job_ids)) {
      action.payload.job_ids.forEach((jobId: string) => {
        if (!params["job_ids"]) params["job_ids"] = [];
        params["job_ids"].push(jobId);
      });
    }

    // Add date range if provided
    if (action.payload?.from_date) params.from_date = action.payload.from_date;
    if (action.payload?.to_date) params.to_date = action.payload.to_date;
    if (action.payload?.matching_percentage) params.matching_percentage = action.payload.matching_percentage;

    console.log("getJobAllStatusCounts params:", params);

    const resp = yield call(CallApi.GET, API_URL.JOB.JOB_ALL_STATUS_COUNTS, params, true);
    console.log("getJobAllStatusCounts response:", resp.data);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    console.log("Error in getJobAllStatusCounts saga:", e);
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}
